import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { eventPageSubPathsWithoutRedirect } from '../constants';
import { ROOT_PATH } from '../../router/constants';
import { useUnitAssignment } from '../../unit-assignment/unit-assignment-context';

export function useAutoNavigateToMainPageWhenUnassigned() {
    const unitAssignment = useUnitAssignment();
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(
        function autoNavigateToTheMainPage() {
            const isSubPathWithoutRedirect = eventPageSubPathsWithoutRedirect.some((subPath) =>
                location.pathname.includes(subPath)
            );

            if (!isSubPathWithoutRedirect && !unitAssignment?.assignedEvent) {
                navigate(ROOT_PATH);
            }
        },
        [navigate, unitAssignment?.assignedEvent, location]
    );
}
